
import React, { Component } from 'react';
import { Modal, Form, Input, Tabs, Row, Col, Switch, Divider, InputNumber, DatePicker, Select } from 'antd';
import moment from 'moment';


import http from '../../../axios/http';
import validator from '../../../util/validator';
import ocr from '../../../util/ocr';
import Loading from '../../ui/Loading';

import messager from '../../ui/messager';
import DictSelect from '../../ui/DictSelect';
import LocalSelect from '../../ui/LocalSelect';
import DictSlider from '../../ui/DictSlider';
import Image from '../../ui/Image';
import ImageUpload from '../../ui/ImageUpload';
import Scanner from '../../ui/Scanner';
//会员选择
import MemberSelect from '../../crm/member/MemberSelect';
import '../../../style/common/uploadImage.css';


const FormItem = Form.Item;
//公司基本信息
const companyInfo = [{
    "text": "营业执照识别",
    "field": "companyOcr",
    image: true
}, {
    "text": "公司名称",
    "field": "companyName",
}, {
    "text": "统一社会信用代码",
    "field": "creditNo",
}, {
    "text": "类 型",
    "field": "type",
}, {
    "text": "住 所",
    "field": "companyAddress",
}, {
    "text": "法定代表人",
    "field": "representative",
}, {
    "text": "注册资本",
    "field": "registeredCapital",
}, {
    "text": "成立日期",
    "field": "establishmentDate",
    "date": true
}, {
    "text": "营业期限",
    "field": "businessTerm",
}, {
    "text": "经营范围",
    "field": "businessScope",
    "textarea": true,
}];
//经办人信息
const operatorInfo = [{
    "text": "身份证识别",
    "field": "idOcr",
    image: true
}, {
    "text": "经办人姓名",
    "field": "managerName",
}, {
    "text": "经办人身份证",
    "field": "idNo",
}, {
    "text": "经办人手机",
    "field": "tel",
    rules: [
        validator.tel
    ],
}, {
    "text": "经办人住址",
    "field": "managerAddress",
},];
//评估基本信息
const assessInfo = [{
    "text": "评估报告号",
    "field": "evaluationNo",
}, {
    "text": "评估报告日",
    "field": "evaluationDate",
    "date": true
}, {
    "text": "评估基准日",
    "field": "evaluationBaseDate",
    "date": true
}, {
    "text": "报告有效期",
    "field": "expires",
    "select": true,
    "category": "EVALUATION_EXPIRES"
}, {
    "text": "报告有效期截止",
    "field": "expiryDate",
    "date": true
}, {
    "text": "评估师",
    "field": "appraiserId",
    "appraiser": true,
}, {
    "text": "复核人",
    "field": "auditorId",
    "appraiser": true,
}];
//鉴定基本信息
const appraisaBasiclInfo = [{
    "text": "行驶证识别",
    "field": "vehicleOCR",
    image: true
}, {
    "text": "车牌号码",
    "field": "plateNo",
}, {
    "text": "车辆类型",
    "field": "vehicleType",
}, {
    "text": "厂牌型号",
    "field": "brandModel",
}, {
    "text": "技术状况鉴定等级",
    "field": "level",
    "category": "EVALUATION_TECHNICAL_LEVEL",
    "select": true,
}, {
    "text": "发动机号",
    "field": "engineNo",
}, {
    "text": "车辆VIN码",
    "field": "vin",
}, {
    "text": "车身颜色",
    "field": "color",
}, {
    "text": "表征里程(km)",
    "field": "mileage",
}, {
    "text": "初次登记日期",
    "field": "registerDate",
    "date": true
}, {
    "text": "年审检验合格至",
    "field": "annualExaminationDate",
    "month": true
}, {
    "text": "车船使用税截至日期",
    "field": "travelTaxDate",
}, {
    "text": "保险截至日期",
    "field": "insuranceDate",
}, {
    "text": "是否查封.抵押车辆",
    "field": "mortgage",
    "yes": true,
}, {
    "text": "车辆购置附加税（费）证",
    "field": "purchaseTax",
    "radio": true,
}, {
    "text": "机动车登记证书",
    "field": "registrationCertificate",
    "radio": true,
}, {
    "text": "机动车行驶证",
    "field": "vehicleLicense",
    "radio": true,
}, {
    "text": "使用性质",
    "field": "useProperty",
    "category": "VALUATION_VEHICLE_USE_PROPERTY",
    "select": true,
}, {
    "text": "重要配置及参数信息",
    "field": "vehicleParameters",
}, {
    "text": "鉴定信息",
    "field": "identificationInfo",
}, {
    "text": "车辆停放地址",
    "field": "vehicleAddress",
}, {
    "text": "实车车况描述",
    "field": "carDescription",
    "textarea": true,
}, {
    "text": "技术状况简述",
    "field": "technicalDescription",
    "textarea": true,
}, {
    "text": "评估说明六",
    "field": "evaluationInstructions",
    "textarea": true,
}];
// 公式计算
const priceData = [{
    "text": "购置价格",
    "field": "purchasePrice",
    "number": true
}, {
    "text": "购置附加税率",
    "field": "additionalTaxRate",
    "number": true

}, {
    "text": "车辆购置相关费用",
    "field": "relatedExpenses",
    "number": true
}, {
    "text": "购置附加税",
    "field": "additionalTax",
    "disabled": true
}, {
    "text": "重置价格",
    "field": "replacementPrice",
    "disabled": true,
    "number": true
}, {
    "text": "其他费用",
    "field": "otherExpenses",
    "disabled": true
}, {
    "text": "规定使用年限",
    "field": "serviceLife",
    "integer": true,
    // "number": true
}, {
    "text": "规定年限折合月",
    "field": "serviceLifeMonth",
    "disabled": true
}, {
    "text": "已使用年限折合月",
    "field": "usedMonth",
    "integer": true,
    // "number": true
}, {
    "text": "年限成新率",
    "field": "newRate",
    "disabled": true
}, {
    "text": "车辆账面原值",
    "field": "originalBookValue",
    "number": true
}, {
    "text": "车辆账面净值",
    "field": "bookValue",
    "number": true
}, {
    "text": "其它调整系数（+）",
    "field": "adjustmentFactorAdd",
    "number": true
}, {
    "text": "其它调整系数（-）",
    "field": "adjustmentFactorMinus",
    "number": true
}];
// 旧机动车车况调整系数
const vehicleCondition = [{
    "text": "技术状况(35%)",
    "field": "technicalCondition",
    "localSel": true,
    "code": 'technicalConditionData'
}, {
    "text": "技术状况得分",
    "field": "technicalConditionScore",
    "disabled": true,
}, {
    "text": "维护(20%)",
    "field": "maintenance",
    "localSel": true,
    "code": 'maintenanceData'
}, {
    "text": "维护得分",
    "field": "maintenanceScore",
    "disabled": true,
}, {
    "text": "制造质量(15%)",
    "field": "quality",
    "localSel": true,
    "code": 'qualityData'
}, {
    "text": "制造质量得分",
    "field": "qualityScore",
    "disabled": true,
}, {
    "text": "工作性质(15%)",
    "field": "workProperty",
    "localSel": true,
    "code": 'workPropertyData'
}, {
    "text": "工作性质得分",
    "field": "workPropertyScore",
    "disabled": true,
}, {
    "text": "工作条件(15%)",
    "field": "workCondition",
    "localSel": true,
    "code": 'workConditionData'
}, {
    "text": "工作条件得分",
    "field": "workConditionScore",
    "disabled": true,
}, {
    "text": "合计得分",
    "field": "totalScore",
    "disabled": true
}];
// 加权调整系数
const weightedAdjust = [{
    "text": "过度行驶(30%)",
    "field": "overdrive",
    "slider": true,
}, {
    "text": "过度行驶得分",
    "field": "overdriveScore",
    "disabled": true,
}, {
    "text": "品牌认知(30%)",
    "field": "brandRecognition",
    "slider": true,
}, {
    "text": "品牌认知得分",
    "field": "brandRecognitionScore",
    "disabled": true,
}, {
    "text": "技术升级(20%)",
    "field": "technologyUpgrade",
    "slider": true,
}, {
    "text": "技术升级得分",
    "field": "technologyUpgradeScore",
    "disabled": true,
}, {
    "text": "停产(20%)",
    "field": "stopProduction",
    "slider": true,
}, {
    "text": "停产得分",
    "field": "stopProductionScore",
    "disabled": true,
}, {
    "text": "合计系数",
    "field": "totalCoefficient",
    "disabled": true
}, {
    "text": "综合系数",
    "field": "synthesisCoefficient",
    "disabled": true
}];
// 公式计算结果 K
const calculationResult = [{
    "text": "计算公式为",
    "field": "calculationFormula",
    "disabled": true
}, {
    "text": "评估价值",
    "field": "evaluationValue",
    "disabled": true
}, {
    "text": "评估增值",
    "field": "valueAdd",
    "disabled": true
}, {
    "text": "增值率",
    "field": "valueAddRate",
    "disabled": true
}];
// 鉴定信息
const appraisalInfo = [
    //     {
    //     "text": "鉴定流水号",
    //     "field": "transferType",
    // },
    {
        "text": "业务类型",
        "field": "businessType",
        "category": "EVALUATION_BUSINESS_TYPE",
        "select": true,

    }, {
        "text": "发动机排量",
        "field": "displacement",
    }, {
        "text": "出厂日期",
        "field": "productionDate",
        "month": true
    }, {
        "text": "车身形状",
        "field": "bodyStructure",
        "category": "EVALUATION_BODY_STRUCTURE",
        "select": true,
    }, {
        "text": "驱动方式",
        "field": "drivingMethod",
        "category": "EVALUATION_DRIVING_METHOD",
        "select": true,
    }, {
        "text": "变速箱",
        "field": "gearboxType",
        "category": "EVALUATION_GEARBOX_TYPE",
        "select": true,
    }, {
        "text": "气囊",
        "field": "airbag",
        "radio": true
    }, {
        "text": "ABS.EBD",
        "field": "abs",
        "radio": true
    }, {
        "text": "涡轮增压",
        "field": "turbo",
        "radio": true
    }, {
        "text": "制动方式",
        "field": "brakeType",
        "category": "EVALUATION_BRAKE_TYPE",
        "select": true,
    }, {
        "text": "燃油种类",
        "field": "fuelType",
        "category": "EVALUATION_FUEL_TYPE",
        "select": true,
    }, {
        "text": "灭火器/三角牌",
        "field": "fireExtinguisher",
        "radio": true
    }, {
        "text": "鉴定报告",
        "field": "appraisalReport",
        "textarea": true,
    }];
// 静态检查
const staticCheck = [{
    "text": "1.保险杠",
    "field": "bumper",
    "radio": true
}, {
    "text": "2.后视镜",
    "field": "rearviewMirror",
    "radio": true
}, {
    "text": "3.车窗 /天窗/玻璃",
    "field": "carWindow",
    "radio": true
}, {
    "text": "4.车轮/轮胎",
    "field": "wheel",
    "radio": true
}, {
    "text": "5.全车灯罩",
    "field": "lampshade",
    "radio": true
}, {
    "text": "6.车身漆面",
    "field": "bodyPaint",
    "radio": true
}, {
    "text": "7.钣金件间隙",
    "field": "metalGap",
    "radio": true
}, {
    "text": "8.封胶/防撞条",
    "field": "sealingGlue",
    "radio": true
}, {
    "text": "9.A.B.C门柱",
    "field": "doorpost",
    "radio": true
}, {
    "text": "10.车身反光标识",
    "field": "reflectiveLogo",
    "radio": true
}, {
    "text": "11.清洁/完整度",
    "field": "cleanliness",
    "radio": true
}, {
    "text": "12.安全带",
    "field": "seatBelt",
    "radio": true
}, {
    "text": "13.车厢灯/门灯",
    "field": "carLights",
    "radio": true
}, {
    "text": "14.仪表/指示器",
    "field": "dashboard",
    "radio": true
}, {
    "text": "15.中控",
    "field": "console",
    "radio": true
}, {
    "text": "16.座椅(电动/真皮)",
    "field": "seat",
    "radio": true
}, {
    "text": "17.地板/顶棚",
    "field": "floorCeiling",
    "radio": true
}, {
    "text": "18.门板/门锁",
    "field": "doorPanel",
    "radio": true
}, {
    "text": "19.清洁/完整度",
    "field": "cleanCompletion",
    "radio": true
}, {
    "text": "20.前/后悬架及阻尼",
    "field": "suspensionDamping",
    "radio": true
}, {
    "text": "21.前/后车桥组合件",
    "field": "axleAssembly",
    "radio": true
}, {
    "text": "22.平衡扭杆",
    "field": "balanceTorsionBar",
    "radio": true
}, {
    "text": "23.前轮主销",
    "field": "frontWheelKingpin",
    "radio": true
}, {
    "text": "24.发动机支架部件",
    "field": "engineBracketParts",
    "radio": true
}, {
    "text": "25.变速器支架部",
    "field": "transmissionBracket",
    "radio": true
}, {
    "text": "26.动力传动各部件",
    "field": "powerTransmission",
    "textarea": true,
    "radio": true
}, {
    "text": "27.转向器及部件",
    "field": "steeringGearParts",
    "radio": true
}, {
    "text": "28.清洁程度",
    "field": "cleanDegree",
    "radio": true
}, {
    "text": "29.发动机机油",
    "field": "engineOil",
    "radio": true
}, {
    "text": "30.散热器及部件",
    "field": "radiatorParts",
    "radio": true
}, {
    "text": "31.制冷部件",
    "field": "refrigerationParts",
    "radio": true
}, {
    "text": "32.转向助力部件",
    "field": "powerSteeringParts",
    "radio": true
}, {
    "text": "33.制动系统部件",
    "field": "brakingParts",
    "radio": true
}, {
    "text": "34.进/排气系统部件",
    "field": "exhaustParts",
    "radio": true
}, {
    "text": "35.供油系统部件",
    "field": "fuelSupplyParts",
    "radio": true
}, {
    "text": "36.蓄电池/电路部件",
    "field": "circuitComponents",
    "radio": true
}, {
    "text": "37.悬架及动力支撑",
    "field": "suspensionPower",
    "radio": true
}, {
    "text": "38.发动机不解体探伤",
    "field": "engineInspection",
    "radio": true
}, {
    "text": "39.燃料管路",
    "field": "fuelLine",
    "radio": true
}, {
    "text": "40.制动管路",
    "field": "brakingLine",
    "radio": true
}, {
    "text": "41.制动分泵",
    "field": "brakeCylinder",
    "radio": true
}, {
    "text": "42.车架纵/横梁",
    "field": "frameBeam",
    "radio": true
}, {
    "text": "43.车舱底板",
    "field": "carFloor",
    "radio": true
}, {
    "text": "44.电器线路",
    "field": "electricalWiring",
    "radio": true
}, {
    "text": "45.排气管/消声器",
    "field": "exhaustPipe",
    "radio": true
}, {
    "text": "46.底盘防护装置",
    "field": "chassisGuard",
    "radio": true
}];
// 动态检查
const dynamicCheck = [{
    "text": "1. 雨刮清洗装置",
    "field": "wiperDevice",
    "radio": true
}, {
    "text": "2. 启动/熄火装置",
    "field": "startStopDevice",
    "radio": true
}, {
    "text": "3.仪表指示信号",
    "field": "indicatorSignal",
    "radio": true
}, {
    "text": "4. 喇叭/倒车警报",
    "field": "hornReverseAlarm",
    "radio": true
}, {
    "text": "5. 前照/转向灯",
    "field": "frontTurnLight",
    "radio": true
}, {
    "text": "6.制动/倒车灯",
    "field": "brakeReversingLights",
    "radio": true
}, {
    "text": "7.防雾/示廓灯",
    "field": "fogMarkerLight",
    "radio": true
}, {
    "text": "8. 其它安全信号灯",
    "field": "otherSafetyLights",
    "radio": true
}, {
    "text": "9.后视镜调节装置",
    "field": "mirrorAdjustingDevice",
    "radio": true
}, {
    "text": "10. 空调制冷功能",
    "field": "airConditionFunction",
    "radio": true
}, {
    "text": "11. 发动机怠速状况",
    "field": "engineIdlingCondition",
    "radio": true
}, {
    "text": "12.加速踏板控制",
    "field": "acceleratorPedal",
    "radio": true
}, {
    "text": "13. 水温/电压状况",
    "field": "waterTemperatureVoltage",
    "radio": true
}, {
    "text": "14. 时速/转速显示",
    "field": "speedRotationDisplay",
    "radio": true
}, {
    "text": "15.发动机提速性能",
    "field": "enginePerformance",
    "radio": true
}, {
    "text": "16. 发动机制动性能",
    "field": "engineBraking",
    "radio": true
}, {
    "text": "17.方向盘最大转动量",
    "field": "maximumSteeringRotation",
    "radio": true
}, {
    "text": "18. 自动回正行驶功能",
    "field": "automaticReturn",
    "radio": true,
}, {
    "text": "19. 变速换档操控性能",
    "field": "gearPerformance",
    "radio": true,
}, {
    "text": "20. 离合器工作性能",
    "field": "clutchPerformance",
    "radio": true,
}, {
    "text": "21. 点制动跑偏（20km/h）",
    "field": "pointBrakeDeviation",
    "radio": true,
}, {
    "text": "22.第三制动（手刹）性能",
    "field": "handBrakePerformance",
    "radio": true,
}, {
    "text": "23. 悬架/阻尼行驶稳定性",
    "field": "suspensionStability",
    "radio": true,
}, {
    "text": "24. 加速状态直线行驶性能",
    "field": "straightDrivingPerformance",
    "radio": true,
}, {
    "text": "25.低至高速状态隔音性能",
    "field": "soundInsulation",
    "radio": true,
}, {
    "text": "26. 空档维持直线滑行性能",
    "field": "neutralSlidingPerformance",
    "radio": true,
}, {
    "text": "27.驾驶平顺/稳定/舒适性能",
    "field": "drivingComfort",
    "radio": true,
}, {
    "text": "28.绕8字圈转向/制动性能",
    "field": "steeringBrakingPerformance",
    "radio": true,
}, {
    "text": "29.自动变速器强制降档功能",
    "field": "kickdownTransmission",
    "radio": true,
}, {
    "text": "30.路试后检查",
    "field": "roadTest",
    "radio": true,
}];

const tradeImage = [{
    text: '委托方提供的营业执照复印件',
    field: 'companyUrl'
}]

class DocumentGenerationEditForm extends Component {
    state = {
        appraiserList: [],
        activeKey: 'deal',
        visible: false,
        imageField: '',
        imageIndex: 0,
        dictSelect: {},
        localSelect: {},
        showAgent: true,
        loading: false,

        //上传特定相关照片
        fileList: {},
        imageUrl: {},
        //其他额外照片
        otherImagesUrl: [],
        otherImage: [],
        inputValue: 0,
        certificateImages: [],
        certificateThumbnail: [],
        vehicleImages: [],
        companyImageUrl: "",
        companyUrl: '',
        technicalConditionData: {
            value: '0.35',
            dictList: [{
                name: '好',
                value: '0.9',
                code: '0'
            }, {
                name: '较好',
                value: '0.7',
                code: '1'
            }, {
                name: '一般',
                value: '0.6',
                code: '2',
            }, {
                name: '较差',
                value: '0.4',
                code: '3',
            }, {
                name: '差',
                value: '0.2',
                code: '4'
            }]
        },
        maintenanceData: {
            value: '0.2',
            dictList: [{
                name: '好',
                value: '0.9',
                code: '0'
            }, {
                name: '一般',
                value: '0.7',
                code: '2',
            }, {
                name: '差',
                value: '0.4',
                code: '3',
            }]
        },
        qualityData: {
            value: '0.15',
            dictList: [{
                name: '进口',
                value: '0.9',
                code: '0'
            }, {
                name: '国产名牌',
                value: '0.7',
                code: '2',
            }, {
                name: '其他品牌',
                value: '0.5',
                code: '3',
            }]
        },
        workPropertyData: {
            value: '0.15',
            dictList: [{
                name: '私用',
                value: '0.9',
                code: '0'
            }, {
                name: '公务、商务',
                value: 0.7,
                code: '2',
            }, {
                name: '营运',
                value: '0.4',
                code: '3',
            }]
        },
        workConditionData: {
            value: '0.15',
            dictList: [{
                name: '好',
                value: '0.9',
                code: '0'
            }, {
                name: '一般',
                value: '0.7',
                code: '2',
            }, {
                name: '差',
                value: '0.5',
                code: '3',
            }]
        },
        calculationFormula: "",
    }

    componentDidMount() {
        http.get({
            url: "/valuationAssessor/findAssessor",
            success: (res) => {
                this.setState({ appraiserList: res })
            }
        });
    }

    componentWillReceiveProps() {
        if (!this.props.visible) {
            let companyThumbnail = this.props.editData.companyThumbnail;
            let companyUrl = this.props.editData.companyUrl;
            let fileList = {};
            if (companyThumbnail != null) {
                companyThumbnail = "data:image/jpeg;base64," + companyThumbnail.replace(/\r\n/g, "");
                this.setState({
                    companyImageUrl: companyThumbnail,
                    companyUrl: companyUrl
                })
            } else {
                this.setState({
                    companyImageUrl: companyThumbnail,
                    companyUrl: ''
                })
            }

            let certificateThumbnail = this.props.editData.certificateThumbnail;
            let certificateImages = [];
            let certificateThumbnailBase64 = [];
            if (certificateThumbnail != null && certificateThumbnail.length > 0) {
                for (let index in certificateThumbnail) {
                    if (certificateThumbnail[index] != null && certificateThumbnail[index] !== "") {
                        certificateThumbnailBase64.push("data:image/jpeg;base64," + certificateThumbnail[index].replace(/\r\n/g, ""));
                    }
                }
                certificateImages = this.props.editData.certificateImages;
            }

            let vehicleImages = this.props.editData.vehicleImages ? this.props.editData.vehicleImages : [];
            this.setState({
                fileList: fileList,
                certificateImages: certificateImages,
                certificateThumbnail: certificateThumbnailBase64,
                vehicleImages: vehicleImages,
            });
        }
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            this.setState({ loadingVisible: true });

            values["id"] = this.props.editData.id;
            // values["image"] = image;

            if (values["establishmentDate"] != null) {
                values["establishmentDate"] = values["establishmentDate"].format("YYYY-MM-DD");
            }
            if (values["evaluationDate"] != null) {
                values["evaluationDate"] = values["evaluationDate"].format("YYYY-MM-DD");
            }
            if (values["evaluationBaseDate"] != null) {
                values["evaluationBaseDate"] = values["evaluationBaseDate"].format("YYYY-MM-DD");
            }
            if (values["registerDate"] != null) {
                values["registerDate"] = values["registerDate"].format("YYYY-MM-DD");
            }
            if (values["annualExaminationDate"] != null) {
                values["annualExaminationDate"] = values["annualExaminationDate"].format("YYYY-MM");
            }
            if (values["productionDate"] != null) {
                values["productionDate"] = values["productionDate"].format("YYYY-MM-DD");
            }
            if (values["expiryDate"] != null) {
                values["expiryDate"] = values["expiryDate"].format("YYYY-MM-DD");
            }

            for (let i = 0; i < staticCheck.length; i++) {
                values[staticCheck[i].field] = values[staticCheck[i].field] ? 1 : 0
            }
            for (let i = 0; i < dynamicCheck.length; i++) {
                values[dynamicCheck[i].field] = values[dynamicCheck[i].field] ? 1 : 0
            }
            values["mortgage"] = values["mortgage"] ? 1 : 0
            values["purchaseTax"] = values["purchaseTax"] ? 1 : 0
            values["registrationCertificate"] = values["registrationCertificate"] ? 1 : 0
            values["vehicleLicense"] = values["vehicleLicense"] ? 1 : 0

            values["abs"] = values["abs"] ? 1 : 0
            values["airbag"] = values["airbag"] ? 1 : 0
            values["fireExtinguisher"] = values["fireExtinguisher"] ? 1 : 0
            values["turbo"] = values["turbo"] ? 1 : 0
            if (this.state.companyUrl !== "") {
                values["companyUrl"] = this.state.companyUrl;
            } else {
                values["companyUrl"] = '';
            }
            values["vehicleImagesJson"] = JSON.stringify(this.state.vehicleImages);
            values["certificateImagesJson"] = JSON.stringify(this.state.certificateImages);


            http.post({
                url: '/evaluation/save',
                data: values,
                success: (res) => {
                    this.props.successCallback();
                    this.props.onCancel();
                    messager.notify("保存成功！");
                    this.setState({ loadingVisible: false });
                },
                error: (res) => {
                    messager.alert(res, "异常", "error");
                    this.setState({ loadingVisible: false });
                }
            });
        });
    };
    transferData = (res, field) => {
        let value = res[field];
        for (let key in value) {
            res[field + "." + key] = value[key];
        }
        delete res[field];
    }
    //字典选择改变时触发
    dictSelect = (field, dict) => {
        if (field === "expires") {
            const { form } = this.props;
            let expires = parseInt(dict.name);
            let expiryDate = null;
            let baseDate = form.getFieldValue("evaluationBaseDate");
            if (baseDate !== null && baseDate !== undefined) {
                if (expires === 1) {
                    expiryDate = baseDate.clone().add(expires, "y");
                }
                else {
                    expiryDate = baseDate.clone().add(expires, "d");
                }
                form.setFieldsValue({
                    expiryDate: expiryDate
                });
            }
        }
    }
    localSelect = (field, dict) => {
        if (dict != null) {
            const { form } = this.props;
            if (field === "technicalCondition") {
                form.setFieldsValue({
                    "technicalConditionScore": (Number(dict.value) * Number(this.state.technicalConditionData.value)).toFixed(3),
                    "technicalCondition": dict.code,
                });
            } else if (field === "maintenance") {
                form.setFieldsValue({
                    "maintenanceScore": (Number(dict.value) * Number(this.state.maintenanceData.value)).toFixed(3),
                    "maintenance": dict.code,
                });
            } else if (field === "quality") {
                form.setFieldsValue({
                    "qualityScore": (Number(dict.value) * Number(this.state.qualityData.value)).toFixed(3),
                    "quality": dict.code,
                });
            } else if (field === "workProperty") {
                form.setFieldsValue({
                    "workPropertyScore": (Number(dict.value) * Number(this.state.workPropertyData.value)).toFixed(3),
                    "workProperty": dict.code
                });
            } else if (field === "workCondition") {
                form.setFieldsValue({
                    "workConditionScore": (Number(dict.value) * Number(this.state.workConditionData.value)).toFixed(3),
                    "workCondition": dict.code
                });
            }
            let technicalConditionScore = Number(form.getFieldValue("technicalConditionScore"));
            let maintenanceScore = Number(form.getFieldValue("maintenanceScore"));
            let qualityScore = Number(form.getFieldValue("qualityScore"));
            let workPropertyScore = Number(form.getFieldValue("workPropertyScore"));
            let workConditionScore = Number(form.getFieldValue("workConditionScore"));

            let totalCoefficient = parseFloat(form.getFieldValue("totalCoefficient")); // 合计系数
            if (technicalConditionScore && maintenanceScore && qualityScore && workPropertyScore && workConditionScore) {
                form.setFieldsValue({
                    "totalScore": ((technicalConditionScore + maintenanceScore + qualityScore + workPropertyScore + workConditionScore) * 100).toFixed(2) + "%", //合计得分
                    "synthesisCoefficient": (((technicalConditionScore + maintenanceScore + qualityScore + workPropertyScore + workConditionScore) * totalCoefficient)).toFixed(2) + "%",  //综合系数
                });
            }

            this.countCalculation();
        }
    }
    //swith选择改变时触发
    radioChange = (field, checked) => {
        const { editData } = this.props;

        if (checked) {
            editData[field] = 1;
        } else {
            editData[field] = 0;
        }
        if (field === "agent") {
            this.setState({ showAgent: checked });
        }
    }
    onRef = (field, dom) => {
        let dictSelect = this.state.dictSelect;
        dictSelect[field] = dom;
        this.setState({ dictSelect: dictSelect });
    }
    onRef1 = (field, dom) => {
        let localSelect = this.state.localSelect;
        localSelect[field] = dom;
        this.setState({ localSelect: localSelect });
    }
    createDom = (data) => {
        let dom = [];
        for (let i = 0; i < data.length; i += 2) {
            let item = (<Row key={i}>
                {/* <Col span={data[i].textarea ? 24 : 12}>
                    {this.createDomItem(data[i])}
                </Col>
                {
                    // 第二条判断full为true则第二条为空
                    data[i].textarea ? '' : (
                        <Col span={11} offset={1}>
                            {(i + 1) < data.length && data[i + 1].text != null ? this.createDomItem(data[i + 1]) : ''}
                        </Col>
                    )
                }  */}
                <Col span={11}>
                    {this.createDomItem(data[i])}
                </Col>
                <Col span={11} offset={2}>
                    {(i + 1) < data.length ? this.createDomItem(data[i + 1]) : ''}
                </Col>
            </Row>);
            dom.push(item);
        }
        return dom;
    };
    monthDiff = (field, date, dateString) => {
        const { form } = this.props;
        let date1 = '';
        let date2 = '';
        let serviceLifeMonth = form.getFieldValue("serviceLifeMonth")
        if (field === "evaluationBaseDate" || field === "registerDate") {
            if (field === "evaluationBaseDate") {
                date1 = dateString;
                date2 = form.getFieldValue('registerDate').format("YYYY-MM-DD");
                //设置截止有效期
                let expiryDate = null;
                let expires = form.getFieldValue("expires");
                let baseDate = date;
                if (baseDate !== null && baseDate !== undefined) {
                    if (expires === "0") {
                        expiryDate = baseDate.clone().add(60, "d");
                    }
                    else if (expires === "1") {
                        expiryDate = baseDate.clone().add(90, "d");
                    }
                    else if (expires === "2") {
                        expiryDate = baseDate.clone().add(120, "d");
                    }
                    else if (expires === "3") {
                        expiryDate = baseDate.clone().add(1, "y");
                    }
                    else if (expires === "4") {
                        expiryDate = baseDate.clone().add(180, "d");
                    }
                    form.setFieldsValue({
                        expiryDate: expiryDate
                    });
                }
            } else if (field === "registerDate") {
                date1 = form.getFieldValue('evaluationBaseDate').format("YYYY-MM-DD");
                date2 = dateString;
            }
            date1 = date1.split('-');
            date1 = parseInt(date1[0]) * 12 + parseInt(date1[1]);
            date2 = date2.split('-');
            date2 = parseInt(date2[0]) * 12 + parseInt(date2[1]);
            var usedMonth = Math.abs(date1 - date2);
            form.setFieldsValue({
                "usedMonth": usedMonth,
                "newRate": ((1 - (usedMonth / serviceLifeMonth)) * 100).toFixed(2) + "%"
            })
        }

    }
    createDomItem = (item) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let domItem = "";
        let payState = editData.payState;
        if (item.agent === true && editData.agent === 0) {

        } else {
            domItem = (
                // <FormItem label={item.text + "："} labelCol={{span: item.textarea?3:6}} wrapperCol={{span: item.textarea?21:18}}>
                <FormItem label={item.text + "："} >
                    {item.image ?
                        <Image openScanner={this.showModal.bind(this, item.field)}
                            onChange={this.handleUploadImage.bind(this, item.field)}
                            type="button" />
                        :
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue:
                                item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                                    : item.month ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                                        : item.radio ? ((editData[item.field] === null || editData[item.field] === undefined) ? true : editData[item.field] === 1)
                                            : item.yes ? ((editData[item.field] === null || editData[item.field] === undefined) ? true : editData[item.field] === 1)
                                                : item.appraiser ? (editData[item.field] === null || editData[item.field] === undefined ? "" : editData[item.field] + "")
                                                    : editData[item.field],
                            valuePropName: item.radio || item.yes ? 'checked' : 'value'
                        })(
                            item.select ?
                                <DictSelect category={item.category} onSelect={this.dictSelect.bind(this, item.field)}
                                    onRef={item.needPull === true ? this.onRef.bind(this, item.field) : null}
                                    disabled={item.payState === true && payState === 1 && editData.agent === 0}
                                />
                                : item.localSel ? <LocalSelect localData={this.state[item.code].dictList} onSelect={this.localSelect.bind(this, item.field)}
                                />
                                    : item.radio ?
                                        <Switch checkedChildren="√" unCheckedChildren="X" onChange={this.radioChange.bind(this, item.field)} disabled={item.payState === true && payState === 1} />
                                        : item.yes ?
                                            <Switch checkedChildren="是" unCheckedChildren="否" onChange={this.radioChange.bind(this, item.field)} disabled={item.payState === true && payState === 1} />
                                            : item.number ?
                                                <InputNumber precision={2} onBlur={this.countPrice.bind(this, item.field)} min={0.00} style={{ width: '100%' }} />
                                                : item.integer ?
                                                <InputNumber precision={0} onBlur={this.countPrice.bind(this, item.field)} min={0} style={{ width: '100%' }} />
                                                : item.date ?
                                                    <DatePicker onChange={this.monthDiff.bind(this, item.field)} style={{ width: '100%' }} />
                                                    : item.month ?
                                                        <DatePicker.MonthPicker style={{ width: '100%' }} />
                                                        : item.member ? <MemberSelect agent={1} onSelect={this.dictSelect.bind(this, item.field)} disabled={item.payState === true && payState === 1} />
                                                            : item.slider ? <DictSlider changeSlider={this.changeSlider.bind(this, item.field)} />
                                                                : item.textarea ? <Input.TextArea disabled={item.disabled === true} />
                                                                    : item.appraiser ?
                                                                        <Select>
                                                                            {this.state.appraiserList.map(d =>
                                                                                <Select.Option key={d["id"]}>{d["name"]}</Select.Option>
                                                                            )}
                                                                        </Select>
                                                                        : <Input disabled={item.disabled === true} onBlur={this.countPrice.bind(this, item.field)} />
                        )
                    }
                </FormItem>
            );
        }
        return domItem;
    }

    countPrice = (field) => {
        const { form } = this.props;
        let purchasePrice = Number(form.getFieldValue('purchasePrice'));//购置价格
        let relatedExpenses = Number(form.getFieldValue('relatedExpenses'));  //车辆购置相关费用
        let additionalTaxRate = Number(form.getFieldValue('additionalTaxRate'));  //购置附加税率

        let newRate = parseFloat(form.getFieldValue("newRate"))  //年限成新率
        let synthesisCoefficient = parseFloat(form.getFieldValue("synthesisCoefficient"))  //综合系数
        let adjustmentFactorAdd = form.getFieldValue("adjustmentFactorAdd");  //其它调整系数+
        let adjustmentFactorMinus = form.getFieldValue("adjustmentFactorMinus");  //其它调整系数-

        let evaluationValue = (purchasePrice * (1 + relatedExpenses) * (synthesisCoefficient / 100) * (newRate / 100) + adjustmentFactorAdd - adjustmentFactorMinus).toFixed(2)
        let bookValue = parseFloat(form.getFieldValue("bookValue"))  //车辆账面净值
        let valueAddRate = parseFloat(form.getFieldValue("valueAddRate"))

        // 车辆账面净值不存在，计算增值率
        if (bookValue === 0) {
            valueAddRate = 0
        } else {
            valueAddRate = ((evaluationValue - bookValue) / bookValue * 100).toFixed(2) + "%"
        }
        form.setFieldsValue({
            "valueAddRate": valueAddRate
        })
        if (field === 'purchasePrice' || field === 'additionalTaxRate' || field === 'relatedExpenses' || field === 'adjustmentFactorAdd' || field === 'adjustmentFactorMinus') {
            form.setFieldsValue({
                "replacementPrice": (purchasePrice * (1 + relatedExpenses)).toFixed(2),    // 重置价格
                "additionalTax": (purchasePrice / (1 + additionalTaxRate) * 0.1).toFixed(2),
                "otherExpenses": (purchasePrice * (1 + relatedExpenses) - purchasePrice - (purchasePrice / (1 + additionalTaxRate) * 0.1).toFixed(2)).toFixed(2),
                "valueAddRate": valueAddRate
            })
        }
        if (field === 'serviceLife') {
            let serviceLife = Number(form.getFieldValue('serviceLife'));  //规定使用年限
            form.setFieldsValue({
                "serviceLifeMonth": serviceLife * 12,
            })
        }
        // 车辆账面净值不存在，计算增值率
        if (field === 'bookValue') {
            let valueAdd = 0;
            if (isNaN(valueAdd)) {
                valueAdd = '';
            } else {
                valueAdd = (evaluationValue - bookValue).toFixed(2);

            }
            form.setFieldsValue({
                "valueAdd": (evaluationValue - bookValue).toFixed(2),
                "valueAddRate": valueAddRate
            })
        }
        let serviceLifeMonth = Number(form.getFieldValue('serviceLifeMonth'));
        let usedMonth = Number(form.getFieldValue('usedMonth'));
        if ((field === 'usedMonth' && usedMonth !== '') || (field === 'serviceLife' && serviceLifeMonth !== '')) {
            form.setFieldsValue({
                "newRate": ((1 - (usedMonth / serviceLifeMonth)) * 100).toFixed(2) + "%",
            })
        }
        if (isNaN(valueAddRate)) {
            form.setFieldsValue({
                "valueAdd": '',
                "valueAddRate": '',
            })
        }
        this.countCalculation();

    }

    changeSlider = (field, value) => {
        const { form } = this.props
        value = Number(value)
        if (field === 'overdrive') {
            form.setFieldsValue({
                "overdrive": value,
                "overdriveScore": (value * 0.3).toFixed(3)
            });
        } else if (field === 'brandRecognition') {
            form.setFieldsValue({
                "brandRecognition": value,
                "brandRecognitionScore": (value * 0.3).toFixed(3)
            });
        } else if (field === 'technologyUpgrade') {
            form.setFieldsValue({
                "technologyUpgrade": value,
                "technologyUpgradeScore": (value * 0.2).toFixed(3)
            });
        } else if (field === 'stopProduction') {
            form.setFieldsValue({
                "stopProduction": value,
                "stopProductionScore": (value * 0.2).toFixed(3)
            });
        }
        let overdrive = Number(form.getFieldValue('overdrive'));
        let brandRecognition = Number(form.getFieldValue('brandRecognition'));
        let technologyUpgrade = Number(form.getFieldValue('technologyUpgrade'));
        let stopProduction = Number(form.getFieldValue('stopProduction'));


        let totalScore = parseFloat(form.getFieldValue('totalScore'))

        let totalCoefficient = ((overdrive * 0.3 + brandRecognition * 0.3 + technologyUpgrade * 0.2 + stopProduction * 0.2) * 100).toFixed(2)
        let synthesisCoefficient = ((totalCoefficient * totalScore) / 100).toFixed(2)

        form.setFieldsValue({
            "totalCoefficient": totalCoefficient + "%",  // 合计系数
            "synthesisCoefficient": synthesisCoefficient + "%",  //综合系数
        });

        this.countCalculation();

    }
    countCalculation = () => {
        const { form } = this.props;
        let purchasePrice = Number(form.getFieldValue('purchasePrice'));//购置价格
        let relatedExpenses = Number(form.getFieldValue('relatedExpenses'));  //车辆购置相关费用
        let newRate = parseFloat(form.getFieldValue("newRate"))  //年限成新率
        let synthesisCoefficientStr = parseFloat(form.getFieldValue("synthesisCoefficient"))  //综合系数
        let synthesisCoefficient = synthesisCoefficientStr + "%"  //综合系数

        let adjustmentFactorAdd = form.getFieldValue("adjustmentFactorAdd");  //其它调整系数+
        adjustmentFactorAdd = adjustmentFactorAdd ? adjustmentFactorAdd : 0;
        let adjustmentFactorMinus = form.getFieldValue("adjustmentFactorMinus");  //其它调整系数-
        adjustmentFactorMinus = adjustmentFactorMinus ? adjustmentFactorMinus : 0;
        let bookValue = parseFloat(form.getFieldValue("bookValue"))  //车辆账面净值
        let evaluationValue = (purchasePrice * (1 + relatedExpenses) * (synthesisCoefficientStr / 100) * (newRate / 100) + adjustmentFactorAdd - adjustmentFactorMinus).toFixed(2)
        let calculationFormula = "￥" + (purchasePrice * (1 + relatedExpenses)).toFixed(2) + "X" + synthesisCoefficientStr + "%X" + newRate + "%+" + adjustmentFactorAdd + "-" + adjustmentFactorMinus + "=" + evaluationValue;
        let valueAddRate = ((evaluationValue - bookValue) / bookValue * 100).toFixed(2)
        let valueAddRateStr = valueAddRate + "%"

        let valueAdd = (evaluationValue - bookValue).toFixed(2);



        if (isNaN(evaluationValue)) {
            evaluationValue = '';
        }

        if (isNaN(valueAdd)) {
            valueAdd = ''
        }
        if (isNaN(valueAddRate)) {
            valueAddRateStr = ''
        }

        form.setFieldsValue({
            "calculationFormula": calculationFormula,
            "evaluationValue": evaluationValue,
            "valueAdd": valueAdd,
            "valueAddRate": valueAddRateStr,
            "synthesisCoefficient": synthesisCoefficient
        })
    }

    createImageDom = (data) => {
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let field = item.field;
            let file = this.state.companyImageUrl;
            dom.push(
                <Col span={4} key={field} style={{ height: '112px' }}>
                    <Image
                        openScanner={this.showModal.bind(this, field)}
                        onChange={this.handleUploadImage.bind(this, field)}
                        onRemove={this.handleRemoveImage.bind(this, field)}
                        file={file}
                        text={item.text}
                        url={this.state.companyUrl}
                    />
                </Col>
            );
        }
        return dom;
    }
    createCertificateImageDom = () => {
        let dom = [];
        let data = this.state.certificateThumbnail;    //缩略图
        const list = this.state.certificateImages;
        for (let i = 0; i <= data.length && i < 6; i++) {
            let file = data[i];
            let url = i < list.length ? list[i] : null;
            dom.push(
                <Col span={3} key={i} style={{ height: '112px' }}>
                    <Image
                        openScanner={this.showModal.bind(this, 'certificateImages')}
                        onChange={this.handleUploadImage.bind(this, 'certificateImages')}
                        onRemove={this.handleRemoveImage.bind(this, 'certificateImages', i)}
                        file={file}
                        text={''}
                        url={url}
                    />
                </Col>
            );
        }
        return dom;
    }
    createVehicleImageDom = () => {
        let dom = [];
        let list = this.state.vehicleImages
        for (let i = 0; i <= list.length && i < 40; i++) {
            let url = i < list.length ? list[i] : null;
            dom.push(
                <Col span={3} key={i} style={{ height: '112px' }}>
                    <ImageUpload
                        openScanner={this.showModal.bind(this, 'vehicleImages')}
                        onChange={this.handleUploadVehicleImage.bind(this)}
                        onMultipleChange={this.handleUploadMultipleImage.bind(this)}
                        onRemove={this.handleRemoveImage.bind(this, 'vehicleImages', i)}
                        multiple={true}
                        text={''}
                        url={url}
                    />
                </Col>
            );
        }
        return dom;
    }

    handleUploadMultipleImage = ({urls}) => {
        let list = this.state.vehicleImages;
        list = list.concat(urls);
        this.setState({ "vehicleImages": list});
    }

    handleUploadVehicleImage = ({url}) => {
        const list = this.state.vehicleImages;
        list.push(url);
        this.setState({ "vehicleImages": list});
    }

    handleUploadImage = (field, { base64 }) => {
        if (field === "vehicleOCR") {
            //调用百度ocr识别
            ocr.baiduOCR({
                image: base64,
                imageType: 'VL',
                callback: (res) => {
                    const { form } = this.props;
                    let registerDate = res["注册日期"]["words"];
                    registerDate = moment(registerDate);
                    let now = new moment();
                    form.setFieldsValue({
                        "vin": res["车辆识别代号"]["words"].replaceAll("O","0").replaceAll("I","1"),
                        "brandModel": res["品牌型号"]["words"],
                        "plateNo": res["号牌号码"]["words"],
                        "engineNo": res["发动机号码"]["words"],
                        "vehicleType": res["车辆类型"]["words"],
                        "registerDate": registerDate,
                        "usedMonth": now.diff(registerDate, "months")
                    });
                }
            });
        } else if (field === 'companyUrl') {
            this.setState({
                companyUrl: base64,
                companyImageUrl: base64
            })

        } else if (field === "idOcr" || field === "companyOcr") {
            const { form } = this.props;
            let imageType = "P1";
            if (field === "idOcr") {
                imageType = 'P1';
            } else if (field === "companyOcr") {
                imageType = 'C3';
                this.setState({
                    companyUrl: base64,
                    companyImageUrl: base64
                })
            }
            //调用百度ocr识别
            ocr.baiduOCR({
                image: base64,
                imageType: imageType,
                idCardSide: 'front',
                callback: (res) => {
                    if (field === "companyOcr") {
                        let establishmentDate = res["成立日期"]["words"];
                        establishmentDate = moment(establishmentDate, "YYYY年MM月DD日");
                        let businessTerm = res["有效期"]["words"];
                        // businessTerm = moment(businessTerm).format("YYYY年MM月DD日");
                        form.setFieldsValue({
                            "creditNo": res["社会信用代码"]["words"],
                            "companyName": res["单位名称"]["words"],
                            "companyAddress": res["地址"]["words"],
                            "businessTerm": "自" + establishmentDate.format("YYYY年M月D日") + " 至 " + businessTerm,
                            "type": res["类型"]["words"],
                            "establishmentDate": establishmentDate,
                            "representative": res["法人"]["words"],
                            "registeredCapital": res["注册资本"]["words"],
                            "businessScope": res["经营范围"]["words"]
                        });
                    } else if (field === "idOcr") {
                        form.setFieldsValue({
                            "idNo": res["公民身份号码"]["words"],
                            "managerName": res["姓名"]["words"],
                            "managerAddress": res["住址"]["words"],
                        });
                    }
                }
            });
        }
        if (field === "certificateImages") {
            const list = this.state.certificateImages;
            const certificateThumbnail = this.state.certificateThumbnail;
            list.push(base64);
            certificateThumbnail.push(base64);
            this.setState({ certificateImages: list, certificateThumbnail: certificateThumbnail });
        }
        else {
            const list = this.state.fileList;
            const imageUrl = this.state.imageUrl;
            if (field === "vehicleOCR") {
                list["vehicleLicense"] = base64;
                delete imageUrl["vehicleLicense"];
            } else {
                list[field] = base64;
                delete imageUrl[field];
            }
            this.setState({ "fileList": list, "imageUrl": imageUrl });
        }
    }
    handleRemoveImage = (field, index) => {
        if (field === "vehicleImages") {
            const list = this.state.vehicleImages;
            list.splice(index, 1);
            this.setState({ "vehicleImages": list});
        } else if (field === "certificateImages") {
            const list = this.state.certificateImages;
            const certificateThumbnail = this.state.certificateThumbnail;
            list.splice(index, 1);
            certificateThumbnail.splice(index, 1);
            this.setState({ "certificateImages": list, "certificateThumbnail": certificateThumbnail });
        } else if (field === 'companyUrl') {
            this.setState({ companyUrl: "", companyImageUrl: "" });
        }
    }
    showModal = (field) => {
        this.setState({ visible: true, imageField: field });
        this.state.initScanner();
    };
    hiddenModal = () => {
        this.setState({ visible: false });
    };
    handleScan = (base64) => {
        if (base64 != null && base64 !== "") {
            base64 = "data:image/jpeg;base64," + base64.replace(/\r\n/g, "");
            if (this.state.imageField === "vehicleImages") {
                const list = this.state.vehicleImages;
                list.push(base64);
                this.setState({ "vehicleImages": list });
            } else if (this.state.imageField === "certificateImages") {
                const list = this.state.certificateImages;
                list.push(base64);
                this.setState({ "certificateImages": list });
            } else {
                const list = this.state.fileList;
                list[this.state.imageField] = base64;
                this.setState({ "fileList": list });
            }
        }
    }


    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={1200}
                visible={visible}
                title="申请信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                //zIndex={1001}
                afterClose={() => {
                    this.setState({ activeKey: 'deal' });
                    this.props.form.resetFields();
                }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <Tabs tabPosition='left' activeKey={this.state.activeKey}
                        onChange={(activeKey) => {
                            this.setState({ activeKey: activeKey });
                        }}
                    >
                        <Tabs.TabPane tab="基本信息" key="deal">
                            <Divider orientation="left" style={{ marginTop: 0 }}>公司基本信息</Divider>
                            {this.createDom(companyInfo)}
                            <Divider orientation="left" style={{ marginTop: 0 }}>经办人信息</Divider>
                            {this.createDom(operatorInfo)}
                            <Divider orientation="left" style={{ marginTop: 0 }}>评估基本信息</Divider>
                            {this.createDom(assessInfo)}
                            <Divider orientation="left" style={{ marginTop: 0 }}>鉴定基本信息</Divider>
                            {this.createDom(appraisaBasiclInfo)}
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="公式计算" key="formula">
                            {this.createDom(priceData)}
                            <Divider orientation="left" style={{ marginTop: 0 }}>旧机动车车况调整系数K</Divider>
                            {this.createDom(vehicleCondition)}
                            <Divider orientation="left" style={{ marginTop: 0 }}>加权调整系数</Divider>
                            {this.createDom(weightedAdjust)}
                            <Divider orientation="left" style={{ marginTop: 0 }}>公式计算结果K</Divider>
                            {this.createDom(calculationResult)}
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="鉴定信息" key="appraisal">
                            {this.createDom(appraisalInfo)}
                            <Divider orientation="left" style={{ marginTop: 0 }}>静态检查</Divider>
                            {this.createDom(staticCheck)}
                            <Divider orientation="left" style={{ marginTop: 0 }}>动态检查</Divider>
                            {this.createDom(dynamicCheck)}
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="图片上传" key="image">
                            <Row>
                                <Divider orientation="left">委托方提供的营业执照复印件</Divider>
                                {this.createImageDom(tradeImage)}
                                <Divider orientation="left">委托方提供的车辆登记证或行驶证等资料复印件</Divider>
                                {this.createCertificateImageDom("certificateImages")}
                                <Divider orientation="left">被评估的二手车实勘照片</Divider>
                                {this.createVehicleImageDom("vehicleImages")}
                            </Row>
                            <Modal visible={this.state.previewVisible} footer={null} onCancel={this.handleCancel}>
                                <img alt="" style={{ width: '100%' }} src={this.state.previewImage} />
                            </Modal>
                        </Tabs.TabPane>
                    </Tabs>

                </Form>
                <Scanner
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    initScanner={(func) => { this.setState({ initScanner: func }) }}
                    onScan={this.handleScan}
                // successCallback={}
                />
                <Loading
                    visible={this.state.loadingVisible}
                    message="正在保存"
                />
            </Modal>
        );
    }
}

const DocumentGenerationEdit = Form.create()(DocumentGenerationEditForm);

export default DocumentGenerationEdit;
